import TelegramRedirect from '@/pages/redirect/telegram';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(redirect)/telegram/')({
  component: TelegramRedirect,
});
